import React from 'react';
import { Page } from '../Common/Components/Page';
import { ReplenishmentPlanManagementContent } from './Components/ReplenishmentPlanManagementContent';
import { EventTriggerProvider } from 'src/EventRuleManagement/Providers/EventTriggerProvider';

export const ReplenishmentPlanManagement = (): React.JSX.Element => (
  <Page title="Replenishment Plans" accessKey={'ekanbanPlans'} isSearchable={true}>
    <EventTriggerProvider>
      <ReplenishmentPlanManagementContent />
    </EventTriggerProvider>
  </Page>
);
